import { render } from "./UnitOfMeasure.vue?vue&type=template&id=52b7778e&scoped=true"
import script from "./UnitOfMeasure.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasure.vue?vue&type=script&lang=js"

import "./UnitOfMeasure.vue?vue&type=style&index=0&id=52b7778e&scoped=true&lang=css"
import "./UnitOfMeasure.vue?vue&type=style&index=1&id=52b7778e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b7778e"]])

export default __exports__